import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Checkbox from "@saleor/components/Checkbox";
import Skeleton from "@saleor/components/Skeleton";
import TableCellHeader from "@saleor/components/TableCellHeader";
import TableHead from "@saleor/components/TableHead";
import { maybe, renderCollection } from "@saleor/misc";
import ProductSku from "@saleor/motherOrders/components/OrderDetailsList/components/ProductSku";
import { StoreOrderDetails_storeOrder } from "@saleor/storeOrders/types/StoreOrderDetails";
import {
  OrderLineStatusEnum,
  SmopOrderStatusEnum
} from "@saleor/types/globalTypes";
import * as React from "react";
import { FormattedMessage } from "react-intl";

import OrderLineStatus from "./OrderLineStatus";

interface TableLinesProps {
  storeOrder: StoreOrderDetails_storeOrder;
  classes;
  checkNotEditable;
  toggleAll;
  listElements;
  onSubmitOrderLineStatus;
  reset;
  editProductDialog;
  isChecked;
  orderStatus;
  onRowClick;
  toggle;
}

const TableLines: React.FC<TableLinesProps> = props => {
  const {
    storeOrder,
    classes,
    checkNotEditable,
    toggleAll,
    listElements,
    onSubmitOrderLineStatus,
    reset,
    editProductDialog,
    isChecked,
    orderStatus,
    onRowClick,
    toggle
  } = props;

  return (
    <div className={classes.tableResponsive}>
      <Table className={classes.table}>
        <colgroup>
          <col />
          <col className={classes.colName} />
          <col className={classes.colQuantity} />
          <col className={classes.colPrice} />
          <col className={classes.colTotal} />
          <col className={classes.colStatus} />
        </colgroup>
        <TableHead
          colSpan={6}
          checkBoxSmallWidth={true}
          className={checkNotEditable ? classes.prodCheckbox : ""}
          disabled={checkNotEditable}
          items={storeOrder && storeOrder.lines}
          toggleAll={toggleAll}
          selected={listElements.length}
          toolbar={
            <div className={classes.toolbarPick}>
              <Button
                id="pickingOrderLineStatusBtn"
                onClick={() => {
                  onSubmitOrderLineStatus(
                    listElements,
                    OrderLineStatusEnum.PICKING
                  );
                  reset();
                }}
              >
                <span className={classes.buttonPicking}>PICKING</span>
              </Button>
              <Button
                id="pickedOrderLineStatusBtn"
                onClick={() => {
                  onSubmitOrderLineStatus(
                    listElements,
                    OrderLineStatusEnum.PICKED
                  );
                  reset();
                }}
              >
                <span className={classes.buttonPicked}>PICKED</span>
              </Button>
              <Button
                id="outofstockOrderLineStatusBtn"
                onClick={() => {
                  editProductDialog({
                    payload: listElements,
                    type: "OUT_OF_STOCK"
                  });
                  reset();
                }}
              >
                <span className={classes.buttonOrange}>OUT OF STOCK</span>
              </Button>
            </div>
          }
        >
          {/* <DisplayColumn column="product" displayColumns={settings.columns}> */}
          <TableCellHeader className={classes.colName}>
            <span className={classes.colNameLabel}>
              <FormattedMessage
                defaultMessage="Product"
                description="product name"
              />
            </span>
          </TableCellHeader>
          {/* </DisplayColumn>
        <DisplayColumn column="qty" displayColumns={settings.columns}> */}
          <TableCell className={classes.colQuantity}>
            <FormattedMessage
              defaultMessage="Qty"
              description="ordered product quantity"
            />
          </TableCell>
          <TableCell className={classes.colPrice}>
            <FormattedMessage
              defaultMessage="Price"
              description="ordered product quantity"
            />
          </TableCell>
          <TableCell className={classes.colTotal}>
            <FormattedMessage
              defaultMessage="Total"
              description="ordered product quantity"
            />
          </TableCell>
          {/* </DisplayColumn>
        <DisplayColumn column="status" displayColumns={settings.columns}> */}
          <TableCell className={classes.colStatus}>
            <FormattedMessage
              defaultMessage="Status"
              description="ordered product status"
            />
          </TableCell>
          {/* </DisplayColumn> */}
        </TableHead>

        <TableBody>
          {renderCollection(
            storeOrder && storeOrder.lines,
            orderDetails => {
              const isSelected = orderDetails
                ? isChecked(orderDetails.id)
                : false;
              return (
                <>
                  <TableRow
                    className={classes.tableRow}
                    selected={isSelected}
                    key={orderDetails ? orderDetails.id : "skeleton"}
                    onClick={
                      checkNotEditable === false ||
                      orderStatus === SmopOrderStatusEnum.NEW_ORDER
                        ? orderDetails &&
                          orderDetails.id &&
                          onRowClick(orderDetails.id)
                        : undefined
                    }
                  >
                    <TableCell
                      className={
                        maybe(() => orderDetails.notes) === ""
                          ? classes.colCheckBox
                          : `${classes.colCheckBox} ${classes.tableRow1}`
                      }
                    >
                      <Checkbox
                        id="editOrderDetailsCheckbox"
                        className={checkNotEditable ? classes.prodCheckbox : ""}
                        disableClickPropagation
                        checked={isSelected}
                        disabled={checkNotEditable}
                        onChange={() => toggle(orderDetails.id)}
                      />
                    </TableCell>

                    <TableCell
                      className={
                        maybe(() => orderDetails.notes) === ""
                          ? classes.colName
                          : `${classes.colName} ${classes.tableRow1}`
                      }
                      style={{ minWidth: "235px" }}
                    >
                      {maybe(() => storeOrder.order) ? (
                        <div style={{ width: "auto" }}>
                          <span
                            className={classes.colNameLabel}
                            style={{ marginRight: "5px" }}
                          >
                            {orderDetails.productName}{" "}
                            {orderDetails.variantName !== "" ||
                            orderDetails.variantName !== undefined
                              ? `(${orderDetails.variantName})`
                              : ""}
                          </span>
                          <ProductSku
                            productSku={maybe(() => orderDetails.variant.sku)}
                          />
                        </div>
                      ) : (
                        <Skeleton />
                      )}
                    </TableCell>
                    <TableCell
                      className={
                        maybe(() => orderDetails.notes) === ""
                          ? classes.colQuantity
                          : `${classes.colQuantity} ${classes.tableRow1}`
                      }
                    >
                      {maybe(() => storeOrder.order) ? (
                        orderDetails.quantity + "x"
                      ) : (
                        <Skeleton />
                      )}
                    </TableCell>
                    <TableCell
                      className={
                        maybe(() => orderDetails.notes) === ""
                          ? classes.colPrice
                          : `${classes.colPrice} ${classes.tableRow1}`
                      }
                    >
                      {maybe(() => storeOrder.order) ? (
                        orderDetails.unitPrice?.gross.amount
                      ) : (
                        <Skeleton />
                      )}
                    </TableCell>
                    <TableCell
                      className={
                        maybe(() => orderDetails.notes) === ""
                          ? classes.colTotal
                          : `${classes.colTotal} ${classes.tableRow1}`
                      }
                    >
                      {maybe(() => storeOrder.order) ? (
                        orderDetails.totalPrice?.gross.amount
                      ) : (
                        <Skeleton />
                      )}
                    </TableCell>
                    <TableCell
                      className={
                        maybe(() => orderDetails.notes) === ""
                          ? classes.colStatusCell
                          : `${classes.colStatusCell} ${classes.tableRow1}`
                      }
                    >
                      <OrderLineStatus
                        status={
                          storeOrder && storeOrder.order
                            ? orderDetails.status
                            : ""
                        }
                      />
                      {/* {maybe(() => storeOrder.order) ? (
                      orderDetails.quantity
                    ) : (
                      <Skeleton />
                    )} */}
                    </TableCell>
                  </TableRow>
                  {maybe(() => orderDetails.notes) === "" ? null : (
                    <TableRow
                      selected={isSelected}
                      onClick={
                        checkNotEditable === false ||
                        orderStatus === SmopOrderStatusEnum.NEW_ORDER
                          ? orderDetails &&
                            orderDetails.id &&
                            onRowClick(orderDetails.id)
                          : undefined
                      }
                    >
                      <TableCell className={classes.tableRow2}></TableCell>
                      <TableCell className={classes.tableRow2} colSpan={5}>
                        <Typography
                          variant="body2"
                          display="block"
                          gutterBottom
                          style={{
                            fontSize: "12px",
                            wordBreak: "break-all"
                          }}
                        >
                          Notes: {maybe(() => orderDetails.notes)}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </>
              );
            },
            () => (
              <TableRow>
                <TableCell colSpan={4}>
                  <FormattedMessage defaultMessage="No products found" />
                </TableCell>
              </TableRow>
            )
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default TableLines;
